(function () {
  angular.module('binky.core.user.avatar', [
    'binky.core.common.member',
    'binky.core.feature',
    'binky.core.lodash',
    'binky.core.promise-utils',
    'binky.core.src2-migration',
  ]);
})();
